import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { validateTemplateTriggers } from '../api/messageTemplatesApi';
import { parseTriggerValidationRowErrors } from '../lib/parseTriggerValidationErrors';

// The endpoint returns 200 `{ valid, triggers }`: valid=true → no errors; valid=false →
// per-row errors keyed by sent index. A 400 (malformed request) is treated as "nothing
// to surface".
export const validateTriggerAssignments = createAsyncThunk(
  'templates/validateTriggers',
  async ({ triggers = [], templateId = null, rowIndices = [] } = {}, { rejectWithValue }) => {
    try {
      const result = await validateTemplateTriggers({ triggers, templateId });
      if (result?.valid) return { rowErrors: {} };
      return parseTriggerValidationRowErrors(result?.triggers, rowIndices);
    } catch {
      return rejectWithValue();
    }
  },
);

const initialState = {
  // Per-row backend errors keyed by form row index.
  rowErrors: {},
};

export const templatesTriggerValidationSlice = createSlice({
  name: 'templatesTriggerValidation',
  initialState,
  reducers: {
    triggerValidationCleared(state) {
      state.rowErrors = {};
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(validateTriggerAssignments.fulfilled, (state, action) => {
        state.rowErrors = action.payload?.rowErrors ?? {};
      })
      .addCase(validateTriggerAssignments.rejected, (state) => {
        state.rowErrors = {};
      });
  },
});

export const { triggerValidationCleared } = templatesTriggerValidationSlice.actions;
export const templatesTriggerValidationReducer = templatesTriggerValidationSlice.reducer;

export const selectTriggerValidationRowErrors = (state) =>
  state.templates.triggerValidation.rowErrors;
